Dashboard.$inject = []
function Dashboard(){

}

export default Dashboard


